/* global dataLayer */
import React from 'react';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import { useStateMachine } from 'little-state-machine';
import { useRouter } from 'next/router';
import Fieldset from 'Components/Fieldset';
import FieldRow from 'Components/FieldRow';
import Field from 'Components/Field';
import ButtonNext from 'Components/ButtonNext';
import Select from 'Components/Select';
import updateAction from 'utils/updateAction';
import s from './Step2.module.scss';

const Step2 = ({ formNamespace, countries }) => {
    const router = useRouter();
    const updateName = (state, payload) => {
        return updateAction(state, payload, formNamespace);
    };
    const { state, actions } = useStateMachine({ updateName });
    const {
        register,
        handleSubmit,
        formState,
        control,
    } = useForm({
        mode: 'onChange',
        defaultValues: state[formNamespace],
    });
    const { errors, isValid } = formState;

    const onSubmit = (data) => {
        dataLayer.push({
            event: 'checkoutSteps',
            eventCategory: 'hyllningsgåva',
            eventAction: 'mottagare',
        });

        Object.assign(data, { steg2: true });
        actions.updateName(data);
        router.push({hash: 'steg3'});
    };

    return (
        <form className={s['Step2']} onSubmit={handleSubmit(onSubmit)}>
            <Fieldset>
                <Field
                    name="giftReceiver1FirstName"
                    label="Förnamn"
                    required={true}
                    register={register('giftReceiver1FirstName', {
                        required: 'Vänligen fyll i förnamn',
                    })}
                    errors={errors}
                />
                <Field
                    name="giftReceiver1LastName"
                    label="Efternamn"
                    required={true}
                    register={register('giftReceiver1LastName', {
                        required: 'Vänligen fyll i efternamn',
                    })}
                    errors={errors}
                />
                <Field
                    name="giftReceiver1Address1"
                    label="Adress"
                    required={true}
                    register={register('giftReceiver1Address1', {
                        required: 'Vänligen fyll i adress',
                    })}
                    errors={errors}
                />
                <FieldRow>
                    <Field
                        name="giftReceiver1Zipcode"
                        label="Postnummer"
                        required={true}
                        register={register('giftReceiver1Zipcode', {
                            required: 'Vänligen fyll i postnummer',
                        })}
                        errors={errors}
                        width="Full"
                    />
                    <Field
                        name="giftReceiver1City"
                        label="Ort"
                        required={true}
                        register={register('giftReceiver1City', {
                            required: 'Vänligen fyll i ort',
                        })}
                        errors={errors}
                        width="Full"
                    />
                </FieldRow>
                <Select
                    name="giftReceiver1Country"
                    label="Land"
                    options={countries}
                    control={control}
                    required={true}
                    errors={errors}
                    register={register('giftReceiver1Country')}
                />
                <Field
                    type="date"
                    name="giftDate"
                    label="Hyllningsdatum"
                    required={true}
                    register={register('giftDate', {
                        required: 'Vänligen fyll i datum',
                    })}
                    errors={errors}
                />
            </Fieldset>
            <ButtonNext disabled={!isValid}>Nästa steg</ButtonNext>
        </form>
    );
};

Step2.propTypes = {
    formNamespace: PropTypes.string,
    countries: PropTypes.array,
};


export default Step2;
